import { useEffect, useState } from "react";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { ApiCourseRequest } from "data/queries/ApiCourse";
import { CustomRendererProps } from "../types";

const UNIT_QUERY = print(gql`
  query EventCertificateResponsibleUnit($id: Int!) {
    EducationalUnit(id: $id) { id visibleName name active }
  }
`);

function Renderer({ data, handleChange, path }: CustomRendererProps<any>): JSX.Element | null {
  const eventTitle = String(data?.title || "").trim();
  const certificateTitle = String(data?.internalContentJSON?.certificate?.title || "").trim();
  const unitId = Number(data?.educationalUnitId || 0);
  const [unitName, setUnitName] = useState("");
  const certificateLocation = String(data?.internalContentJSON?.certificate?.location || "").trim();
  const certificateTemplate = data?.internalContentJSON?.certificate?.template;
  const certificateOrientation = data?.internalContentJSON?.certificate?.orientation;

  useEffect(() => {
    if (!unitId || certificateLocation) return;
    ApiCourseRequest<any>({ query: UNIT_QUERY, variables: { id: unitId } })
      .then((response) => {
        const unit = response.data.data?.EducationalUnit;
        if (unit?.active) setUnitName(String(unit.visibleName || unit.name || "").trim());
      })
      .catch(() => setUnitName(""));
  }, [unitId, certificateLocation]);

  useEffect(() => {
    const defaults = {
      ...(!certificateTitle && eventTitle ? { title: eventTitle } : {}),
      ...(!certificateLocation && unitName ? { location: unitName } : {}),
      ...(certificateTemplate !== "INSTITUTIONAL" ? { template: "INSTITUTIONAL" } : {}),
      ...(certificateOrientation !== "LANDSCAPE" ? { orientation: "LANDSCAPE" } : {}),
    };
    if (!Object.keys(defaults).length) return;
    handleChange(path, {
      ...data,
      internalContentJSON: {
        ...(data?.internalContentJSON || {}),
        certificate: {
          ...(data?.internalContentJSON?.certificate || {}),
          ...defaults,
        },
      },
    });
  }, [eventTitle, certificateTitle, unitName, certificateLocation, certificateTemplate, certificateOrientation]);

  return null;
}

export default withJsonFormsControlProps(Renderer);
